import { useState, useEffect, useContext } from 'react'
import "./style.scss"
import { toAbsoluteUrl } from '../../../utils/assetHelper';
import { downloadPdf as download } from '../../../utils/downloader'
import {isVideoFile, getMp4Url, isGif} from '../../../utils/videoHelper'
import { methodologyNameMapping, methodologyShortName } from '../../../utils/methodology';
import { wrapBoxWithColorClass } from '../../../utils/htmlConversion';
import 'react-quill/dist/quill.snow.css';
import { AuthContext } from "../../../context/auth";
import { getProductFromListApi } from '../../../api'
import {
  Magnifier,
  GlassMagnifier,
  MOUSE_ACTIVATION,
  TOUCH_ACTIVATION
} from "@vanyapr/react-image-magnifiers";
import ImageViewer from "awesome-image-viewer";
import { useNavigate } from 'react-router-dom';
import { useMixPanel } from '../../../hooks/useMixPanel';
import { useGtag } from '../../../hooks/useGtag';
import Skeleton from "react-loading-skeleton";


const Index = ({ setOpenMethodologyModal, selectedProduct, setSelectedProduct, modalName, setModalName, galleryView, setPreviewProduct, setOpenItemPreviewModal, createSlug=false }) => {
  const navigate = useNavigate()
  const { mixPanelEvent, mixPanelServerEvent } = useMixPanel()
  const { gtagViewDownloadEvent } = useGtag()
  const { width, setIsLoading, isLoading, setNotification } = useContext(AuthContext)
  const [methodologyData, setMethodologyData] = useState(null)
  const [images, setImages] = useState([])
  const [index, setIndex] = useState(0)

  useEffect(() => {
  if (selectedProduct && modalName) {
    const targetName = methodologyNameMapping[modalName] || modalName;

    const selectedImageData = selectedProduct?.metadata?.images?.find(
      (item) => item?.name === targetName
    );

    if (selectedImageData) {
      if (!selectedImageData?.other_images) {
        const otherImages = selectedProduct?.metadata?.images?.filter((item) => item.url !== '')

        setMethodologyData({
          ...selectedImageData,
          other_images: otherImages,
          product_name: selectedProduct?.title,
          product_id: selectedProduct?.id,
          product_handle: selectedProduct?.handle
        });
      } else {
        setMethodologyData(selectedImageData);
      }
    }
  }
}, [selectedProduct, modalName]);

  const props = { zoomPosition: 'left', zoomStyle: 'background-color: white;', scale: 1, img: methodologyData?.url || toAbsoluteUrl("/media/methodologyplaceholder.png") }

  const getProductFromList = (id) => {
    setIsLoading(true)
    getProductFromListApi(id).then(res => {
      if (res && res.data) {
        setPreviewProduct(res?.data?.products[0])
        setIsLoading(false)
        setOpenItemPreviewModal(true)
      }
      setIsLoading(false)
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }


  useEffect(() => {
    if (methodologyData?.url) {
      setIsLoading(true)
      const sortedImages = methodologyData?.other_images.sort((a, b) => {
        if (a.name === modalName) return -1;
        if (b.name === modalName) return 1;
        return a.name.localeCompare(b.name);
      });
      setImages(sortedImages?.map(image => ({
        mainUrl: image?.url ? `${process.env.REACT_APP_GALLERY_URL}2000:2000:${image?.url?.split('.com/')[1]}` : '',
        ...image
      })))
      setIsLoading(false)
    } else {
      setImages([])
    }
  }, [methodologyData])

  const openPrintDialog = (pdfUrl) => {
    window.open(pdfUrl, '_blank')
    const data = {
        product_id: methodologyData?.product_id,
        type: images[index]?.name || modalName,
        product_name: methodologyData?.product_name 
      }
      mixPanelEvent('PDF Download', data)
      mixPanelServerEvent('PDF Download', data)
      gtagViewDownloadEvent('pdf_download', data)
  }

  const downloadImage = () => {
    const url = `${process.env.REACT_APP_GALLERY_URL}2000:2000:${images[index]?.url?.split('.com/')[1]}`
    const fileName = `${methodologyData?.product_name}-${images[index]?.name}.${images[index]?.url?.split('.com/')[1].split('.')[1] ?? 'jpg'}`
    download(url, fileName)
    const data =  {
      product_id: methodologyData?.product_id,
      type: images[index]?.name || modalName,
      product_name: methodologyData?.product_name,
      file_name: fileName,
      file_url: url
    }
    mixPanelEvent('Image Download', data)
    mixPanelServerEvent('Image Download', data)
    gtagViewDownloadEvent('image_download', data)
  }

  const trackImageView = () => {
  if (methodologyData?.url) {
    const data = {
      product_id: methodologyData?.product_id,
      type: images[index]?.name || modalName,
      product_name: methodologyData?.product_name,
      file_name: images[index]?.name,
      file_url: images[index]?.url
    }
    mixPanelEvent('Image View', data)
    mixPanelServerEvent('Image View', data)
    gtagViewDownloadEvent('image_view', data)
  }
  }

  return (
    <div className="small-modal-wrapper">
      <div className={`small-modal-content methodology-modal-content`}>
      {methodologyData?.url && 
      <span className='close close-modal-btn download-btn' onClick={() => {
        downloadImage()
        }}><i className="fal fa-download"></i></span>
      }
        <span className='close close-modal-btn' onClick={() => {
          setOpenMethodologyModal(false)
          setModalName(null)
          if (createSlug) {
            navigate('/product-search')
          }
        }}><i className="fas fa-times"></i></span>
        <div className="img-container">
          {isLoading && <h4 className='loading'>Loading...</h4>}
          <>
          {
          isVideoFile(methodologyData) ?
          <video src={getMp4Url(images[index]?.url)} controls loop autoPlay={true} muted={true} playsInline
          style={{width:'100%'}}
          onLoadedData={() => {
            setIsLoading(false)
            trackImageView()
          }}
         />
          :
          isGif(methodologyData) ?
          <img src={images[index]?.url} alt="methodology" style={{width:'100%'}} 
          onLoad={() => {
            setIsLoading(false)
            trackImageView()
          }}
          />
          :
        (!methodologyData?.url || isLoading) ? 
          <Skeleton containerClassName='skeleton-container' height={'100%'} baseColor='#e0e0e0' />
          :
          width > 1200 ? (
          <GlassMagnifier
            className="input-position"
            style={{ visibility: isLoading ? 'hidden' : 'visible' }}
            imageSrc={methodologyData && methodologyData?.url ? `${process.env.REACT_APP_GALLERY_URL}800:850:${images[index]?.url?.split('.com/')[1]}` : ""}
            largeImageSrc={methodologyData && methodologyData?.url ? `${process.env.REACT_APP_GALLERY_URL}1200:1250:${images[index]?.url?.split('.com/')[1]}` : ""}
            allowOverflow={false}
            magnifierSize={'20%'}
            magnifierBorderSize={3}
            magnifierBorderColor={'rgba(255, 255, 255, .5)'}
            square={true}
            onImageLoad={() => {
              setIsLoading(false)
              trackImageView()
            }}
            />
          )
          :
          <Magnifier
              className="input-position"
              style={{ visibility: isLoading ? 'hidden' : 'visible' }}
              imageSrc={methodologyData?.url ? `${process.env.REACT_APP_GALLERY_URL}800:850:${images[index]?.url?.split('.com/')[1]}` : ""}
              largeImageSrc={methodologyData?.url ? `${process.env.REACT_APP_GALLERY_URL}1600:1650:${images[index]?.url?.split('.com/')[1]}` : ""}
              mouseActivation={MOUSE_ACTIVATION.CLICK}
              touchActivation={TOUCH_ACTIVATION.CLICK}
              dragToMove={true}
              onImageLoad={() => {
                setIsLoading(false)
                trackImageView()
              }}
            />
          }
          </>
        {images && images.length > 1 && <div className='other-images-btns'>
          <button className='btn' disabled={isLoading} style={{ margin: 0, width: 'max-content', padding: '6px 10px', maxHeight: 'max-content' }} onClick={() => {
            if(index > 0) {
              setIndex(index - 1)
              if (createSlug){
                navigate(`/product-search/${methodologyData?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === images[index - 1]?.name) || images[index - 1]?.name}`)
              }
            } else {
              setIndex(images.length - 1)
              if (createSlug){
              navigate(`/product-search/${methodologyData?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === images[images.length - 1]?.name) || images[images.length - 1]?.name}`)
              }
            }
          }}>Prev Image</button>
          <button className='btn' disabled={isLoading} style={{ margin: 0, width: 'max-content', padding: '6px 10px', maxHeight: 'max-content' }} onClick={() => {
            if(index < images.length - 1) {
              setIndex(index + 1)
               if (createSlug){
              navigate(`/product-search/${methodologyData?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === images[index + 1]?.name) || images[index + 1]?.name}`)
              }
            } else{
              setIndex(0)
              if (createSlug) {
                navigate(`/product-search/${methodologyData?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === images[0]?.name) || images[0]?.name}`)
              }
            }
          }}>Next Image</button>
          </div>
        }
          {galleryView && <button className='btn view-product' disabled={isLoading} style={{ margin: 0, width: 'max-content', padding: '6px 10px', maxHeight: 'max-content' }} onClick={() => {
            getProductFromList(methodologyData?.product_id)
            if (createSlug) {
              navigate(`/product-search/${methodologyData?.product_handle}`, { state: { fromMethodology: `${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === modalName) || modalName}` } })
            }
          }}><i className='fas fa-eye'></i> View Product</button>
          }
         {!isVideoFile(methodologyData) && methodologyData?.url && <button className='btn view-full-image' disabled={isLoading} style={{ margin: 0, width: 'max-content', padding: '6px 10px', maxHeight: 'max-content' }} onClick={() => {
            new ImageViewer({
              images: images?.filter((_i) => _i.url !== ''),
              closeOnEsc: true,
              isZoomable: false,
              closeOnOutsideClick: true
            })
            trackImageView()
          }}
          >{methodologyData?.other_images && methodologyData?.other_images.length > 1 ? "View All Images" : "View Image"}</button>
        }
        </div>
        <div className="methods-text">
          <h3>{modalName ? images[index]?.name || modalName : ""}
          </h3>
          <div className='ql-snow'>
            {images[index]?.methods ? <p className='method ql-editor' dangerouslySetInnerHTML={{ __html: images[index]?.methods ? wrapBoxWithColorClass(images[index]?.methods) : "No Methodology Available" }}></p>
              : <p style={{ padding: '12px 10px', background: '#FFF2E5', borderRadius: '12px', color: '#DC4405', fontWeight: 700 }}>Data Collection In Progress</p>
            }
          </div>
          <div className='methodologybtn-container'>
        {methodologyData?.url && <button className='btn share-btn' onClick={() => {
        navigator.clipboard.writeText(`${window.location.origin}/product-search/${methodologyData?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === images[index]?.name).replace(/ /g, '%20')}`)
        setNotification({ type: "success", message: "Link copied" })
        }}><i className='fal fa-share-alt'></i> Share</button>
        }
        {(images[index]?.pdf && images[index]?.methods) &&
          <button className='btn' onClick={() => {
            openPrintDialog(images[index]?.pdf)
          }}>Print PDF</button>
        }
        <button className='btn transparent' onClick={() => {
            setOpenMethodologyModal(false)
            setModalName("")
            if (createSlug) {
              navigate('/product-search')
            }
            // setSelectedProduct(null)
        }}>Close</button>
        </div>
        </div>
      </div>

    </div>
  )
}

export default Index
